export const sum = (arr: number[]): number =>
  arr.reduce(
    (acc, curr) => acc + curr,
    0,
  )
